
  export const currentPriceCodes = {
    Monthly: process.env.NEXT_PUBLIC_ZONADO_PRO_MONTHLY,
    Annual: process.env.NEXT_PUBLIC_ZONADO_PRO_ANNUAL,
  };


  export const boostPriceCodes = {
    Monthly: process.env.NEXT_PUBLIC_BOOST_MONTHLY,
    Quarterly: process.env.NEXT_PUBLIC_BOOST_QUARTERLY,
  };

  export const currentPrices = {
    Monthly: 39.99,
    Annual: 399.90,
    AnnualSavings: function() {
      return (this.Monthly * 12 - this.Annual).toFixed(2);
    },
    AnnualEffectiveMonthlyRate: function() {
      return (this.Annual / 12).toFixed(2);
    }
  }

  export const boostPrices = {
    Monthly: 199.99,
    Quarterly: 149.99,
    QuarterlySavings: function() {
      return (this.Monthly * 3 - this.Quarterly * 3).toFixed(2);
    },
    AnnualEffectiveMonthlyRate: function() {
      return (this.Annual / 12).toFixed(2);
    }
  }